export default "__VITE_ASSET__CyUVGJ6g__"